import React, { useEffect, useState } from "react";
import "./exam.scss";
import EmptyState from "../../../shared/components/EmptyState";
import { ExamService } from "../../../services/ExamService/exam.service";
import ExamComponent from "../../../shared/components/ExamComponents/ExamCard/index";
import CourseHeader from "../../../shared/components/AppHeader/index";
import ExamForm from "../../../shared/components/ExamComponents/ExamForm";
import PaginationComponent from "../../../shared/components/PaginationComponent";
const Exams = () => {
  const [exams, setExams] = useState<any>([]);
  const [meta, setMeta] = useState<any>();
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [showForm, setFormVisibility] = useState(false);
  const getExams = (pageNumber: number, searchString?: string) => {
    let queryParams = `?page=${pageNumber}&search=${searchString || ""}`;

    ExamService.fetchExams(
      queryParams,
      (exams: any, meta: any) => {
        setExams(exams);
        setMeta(meta);
      },
      (error: any) => {}
    );
  };
  const handleSearch = (value: string) => {
    getExams(currentPageNumber, value);
  };

  const handlePageChange = (page: number) => {
    getExams(page);
    setCurrentPageNumber(page);
  };

  useEffect(() => {
    getExams(1);
  }, []);
  return (
    <div className="page-view">
      <ExamForm
        visible={showForm}
        title={"Create New Exam"}
        setVisible={setFormVisibility}
        refreshList={getExams}
        currentPageNumber={currentPageNumber}
      />
      <CourseHeader
        headerText="Exams"
        handleSearch={handleSearch}
        handleHeaderAction={() => {
          setFormVisibility(true);
        }}
        buttonText="Exam"
      />
      {exams.length > 0 ? (
        <>
          <ExamComponent
            exams={exams}
            refreshList={getExams}
            currentPageNumber={currentPageNumber}
          />
          <PaginationComponent
            handlePageChange={handlePageChange}
            paginationMeta={meta}
          />
        </>
      ) : (
        <EmptyState text={"No exams found."} />
      )}
    </div>
  );
};

export default Exams;
